module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_shizuoka-e2a1e49c99af7fea878eb11c70842151.png";